// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import RichText from '@tcp/core/src/components/common/atoms/RichText';
import withStyles from '../../../hoc/withStyles';
import styles from '../styles/PromotionBanner.style';
import CONSTANTS from '../../../../features/CnC/Checkout/Checkout.constants';
import { getDynamicLabelValues, renderLabel } from '../../../../../utils/labels/labelUtilty';

/**
 *
 * @function modifiedBannerText
 * @description this method replcae label's dynamic value of tcpsegment with another respective label.
 * @param {*} label
 * @returns
 * @memberof PromotionBanner
 */
const modifiedBannerText = (label, props, labels) => {
  const { bossBanner, tcpSegmentValue, itemBrand } = props;
  const brandName = itemBrand && itemBrand.toLowerCase();
  const pickupType = bossBanner
    ? CONSTANTS.ORDER_ITEM_TYPE.BOSS.toLowerCase()
    : CONSTANTS.ORDER_ITEM_TYPE.BOPIS.toLowerCase();
  return label?.replace(
    /\$tcpSegmentValue\$/,
    labels[`lbl_banner_${pickupType}_disc_${brandName}_${tcpSegmentValue}`]
      ? labels[`lbl_banner_${pickupType}_disc_${brandName}_${tcpSegmentValue}`]
      : labels[`lbl_banner_${pickupType}_disc_${brandName}_default`]
  );
};

const PromotionBanner = (props) => {
  const {
    fullBleed,
    className,
    isPickupMobilePromotion,
    isAddedToBagRedesign,
    isBossMultipleStoreEnabled,
    isNewChangeStoreUIEnabledCNC,
    isSPC,
    isShoppingBag,
    fromBossSwitch,
  } = props;
  const labels = getDynamicLabelValues(`dynamic.browse_d`);
  const fullBleedBannerBossText = renderLabel(
    labels.lbl_fullBleed_banner_boss_text,
    'lbl_fullBleed_banner_boss_text'
  );
  const bannerBossText = renderLabel(labels.lbl_banner_boss_text, 'lbl_banner_boss_text');

  const triangleClass = !isPickupMobilePromotion ? 'triangle-left' : 'triangle-top';
  return (
    <div className={className}>
      {fullBleed ? (
        <div className="fullBleedBanner">
          <Row className="banner">
            <Col
              key="productDetails"
              className="pickUp"
              colSize={{ small: 6, medium: 8, large: 12 }}
              textAlign="center"
            >
              <BodyCopy
                dataLocator="addedtobag-bossbanner"
                tag="span"
                fontSize="fs12"
                textAlign="center"
                className={`addedtobag-bossbanner ${
                  isAddedToBagRedesign ? 'is-added-to-bag-redesign' : ''
                }`}
              >
                <RichText
                  richTextHtml={modifiedBannerText(fullBleedBannerBossText, props, labels)}
                />
              </BodyCopy>
            </Col>
          </Row>
        </div>
      ) : (
        <div className="banner-wrapper">
          {bannerBossText && bannerBossText.length ? (
            <>
              {!isBossMultipleStoreEnabled && <div className={triangleClass} />}
              <div className="promo-wrapper">
                {(!(isNewChangeStoreUIEnabledCNC && (isSPC || isShoppingBag)) ||
                  fromBossSwitch) && (
                  <div className="richtextCss">
                    <RichText richTextHtml={modifiedBannerText(bannerBossText, props, labels)} />
                  </div>
                )}
              </div>
            </>
          ) : null}
        </div>
      )}
    </div>
  );
};

PromotionBanner.propTypes = {
  fullBleed: PropTypes.bool,
  className: PropTypes.string.isRequired,
  isPickupMobilePromotion: PropTypes.bool,
  isAddedToBagRedesign: PropTypes.bool,
};

PromotionBanner.defaultProps = {
  fullBleed: false,
  isPickupMobilePromotion: false,
  isAddedToBagRedesign: false,
};

export default withStyles(PromotionBanner, styles);
export { PromotionBanner as PromotionBannerVanilla };
